import type { Scenario } from '../types';

export const batteryScenario: Scenario & {
  title: string;
  description: string;
} = {
  id: 'battery',
  name: 'Battery Drain Investigation',
  title: 'Battery Drain Investigation',
  description:
    'A user reports their laptop battery drains from 100% to 20% within an hour.',
  initialState: {
    isFixed: true,
    ipReleased: false,
    batteryReportGenerated: false,
    batteryIssueIdentified: false,
    actionLog: [],
    openWindows: [],
    activeWindow: null,
  },
  desktopIcons: [
    {
      id: 'ico-network',
      label: 'Network Settings',
      emoji: '📶',
      opensApp: 'network-settings',
    },
    {
      id: 'ico-pc',
      label: 'This PC',
      emoji: '🖥️',
      opensApp: 'this-pc',
    },
    {
      id: 'ico-bin',
      label: 'Recycle Bin',
      emoji: '🗑️',
      opensApp: 'recycle-bin',
    },
    {
      id: 'ico-cmd',
      label: 'Command Prompt',
      emoji: '⬛',
      opensApp: 'command-prompt',
    },
  ],
  availableApps: [
    'network-settings',
    'command-prompt',
    'this-pc',
    'recycle-bin',
  ],
};
